package com.patronat.top.client.data.profile

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.ContactSupportRequest
import com.patronat.top.dto.ContactSupportResponse
import com.patronat.top.dto.DeleteCurrentUserRequest
import com.patronat.top.dto.ProfileSuccessResponse
import com.patronat.top.dto.UpdateCurrentUserRequest
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody

class ClientProfileRemoteDataSource(
    private val httpClient: HttpClient
) {
    suspend fun getCurrentUser(): NetworkResult<ProfileSuccessResponse> {
        return safeApiCall {
            httpClient.get("users/me")
        }
    }

    suspend fun updateCurrentUser(request: UpdateCurrentUserRequest): NetworkResult<ProfileSuccessResponse> {
        return safeApiCall {
            httpClient.put("users/me") {
                setBody(request)
            }
        }
    }

    suspend fun submitContactMessage(request: ContactSupportRequest): NetworkResult<ContactSupportResponse> {
        return safeApiCall {
            httpClient.post("support/messages") {
                setBody(request)
            }
        }
    }

    suspend fun deleteCurrentUser(request: DeleteCurrentUserRequest): NetworkResult<Unit> {
        return safeApiCall {
            httpClient.post("users/me/delete") {
                setBody(request)
            }
        }
    }
}
